export const INFO_PAGE = {
  NOT_ALLOWED: {
    image: "/not_allowed.png",
    title: "infoPages.notAllowed.title",
    text: "infoPages.notAllowed.text",
    alt: "infoPages.notAllowed.alt",
  },
  NOT_FOUND: {
    image: "/not_found.png",
    title: "infoPages.notFound.title",
    text: "infoPages.notFound.text",
    alt: "infoPages.notFound.alt",
  },
  UNDER_CONSTRUCTION: {
    image: "/not_found.png",
    title: "infoPages.notFound.title",
    text: "infoPages.notFound.text",
    alt: "infoPages.notFound.alt",
  },
};
